/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitPrivacyInfoResult
 */
export interface MonitPrivacyInfoResult {
    /**
     * 
     * @type {string}
     * @memberof MonitPrivacyInfoResult
     */
    do_not_sell_link: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitPrivacyInfoResult
     */
    has_gpc: boolean;
    /**
     * 
     * @type {string}
     * @memberof MonitPrivacyInfoResult
     */
    privacy_policy_link: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof MonitPrivacyInfoResult
     */
    social_media_links?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof MonitPrivacyInfoResult
     */
    app_store_links?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof MonitPrivacyInfoResult
     */
    trackers: { [key: string]: Array<string>; };
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof MonitPrivacyInfoResult
     */
    meta: { [key: string]: { [key: string]: any; }; };
}

/**
 * Check if a given object implements the MonitPrivacyInfoResult interface.
 */
export function instanceOfMonitPrivacyInfoResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "do_not_sell_link" in value;
    isInstance = isInstance && "has_gpc" in value;
    isInstance = isInstance && "privacy_policy_link" in value;
    isInstance = isInstance && "trackers" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function MonitPrivacyInfoResultFromJSON(json: any): MonitPrivacyInfoResult {
    return MonitPrivacyInfoResultFromJSONTyped(json, false);
}

export function MonitPrivacyInfoResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPrivacyInfoResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'do_not_sell_link': json['do_not_sell_link'],
        'has_gpc': json['has_gpc'],
        'privacy_policy_link': json['privacy_policy_link'],
        'social_media_links': !exists(json, 'social_media_links') ? undefined : json['social_media_links'],
        'app_store_links': !exists(json, 'app_store_links') ? undefined : json['app_store_links'],
        'trackers': json['trackers'],
        'meta': json['meta'],
    };
}

export function MonitPrivacyInfoResultToJSON(value?: MonitPrivacyInfoResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'do_not_sell_link': value.do_not_sell_link,
        'has_gpc': value.has_gpc,
        'privacy_policy_link': value.privacy_policy_link,
        'social_media_links': value.social_media_links,
        'app_store_links': value.app_store_links,
        'trackers': value.trackers,
        'meta': value.meta,
    };
}

